// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type FreeDay, FreeDayCreate } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useCreateFreeDay(): (
  requestBody: FreeDayCreate
) => Promise<FreeDay> {
  const getAPI = useGetApi();
  return useCallback(
    async (requestBody) =>
      (await getAPI()).freeDays.createFreeDay({ requestBody }),
    [getAPI]
  );
}
